import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { lostPasswordFirstStep } from '../services';
import useAlert from 'utils/alert';

const useLostPassword = (handleReset, initialLastStep = false) => {
  const { t } = useTranslation();
  const [error, serError] = useState(false);
  const [lastStep, setLastStep] = useState(initialLastStep);
  const [showPasswords, setshowPasswords] = useState(false);

  const showAlert = useAlert();

  const handleSubmitLostPassword = async (data) => {
    serError(false);
    try {
      await lostPasswordFirstStep(data);
      if (!lastStep) {
        setLastStep(true);
      } else {
        showAlert(t('auth:password-updated'), 'success');
        handleReset();
      }
    } catch (err) {
      serError(true);
      showAlert(t('auth:error-try-again'), 'error');
    }
  };

  const handleShowPassword = () => {
    setshowPasswords(!showPasswords);
  };

  const toggleLastStep = () => {
    setLastStep(!lastStep);
  };

  return {
    handleSubmitLostPassword,
    error,
    lastStep,
    showPasswords,
    handleShowPassword,
    toggleLastStep,
  };
};

export default useLostPassword;
